import React from 'react';
import { Grid } from 'semantic-ui-react';
import { Field } from 'redux-form';
import PropTypes from 'prop-types';

import { AssignEntitiesEnum } from 'Common/FieldEnum';
import { SiteGridContainer } from '../../containers/assignEntities/SiteGridContainer';
import { ItemGridContainer } from '../../containers/assignEntities/ItemGridContainer';

const AssignSiteToItemsComponent = props => {
  const {
    allSitesData,
    loadingAllSites,
    loadingAllItems,
    allItemsData,
    resetGridPage,
    onResetPageOnDataChange,
    setIsReadOnlyState,
    isReadOnly,
    setSiteGridInstance,
    setItemGridInstance,
    rightSideGridReactTableRef,
    onFilteredChange,
    direction,
  } = props;

  return (
    <Grid>
      <Grid.Row columns={2}>
        <Grid.Column width={6}>
          <Field
            component={SiteGridContainer}
            name={AssignEntitiesEnum.SiteGridInfo}
            {...{
              dataSource: allSitesData,
              loadingAllSites,
              isLeftSideSiteGrid: true,
              isRightSideItemGrid: true,
              setIsReadOnlyState,
              isReadOnly,
              setSiteGridInstance,
              onResetPageOnDataChange,
              resetGridPage,
              direction,
            }}
          />
        </Grid.Column>
        <Grid.Column width={10}>
          <Field
            component={ItemGridContainer}
            name={AssignEntitiesEnum.ItemGridInfo}
            {...{
              dataSource: allItemsData,
              loadingAllItems,
              isLeftSideSiteGrid: true,
              isRightSideItemGrid: true,
              setIsReadOnlyState,
              isReadOnly,
              setItemGridInstance,
              rightSideGridReactTableRef,
              onFilteredChange,
              resetGridPage,
              onResetPageOnDataChange,
              direction,
            }}
          />
        </Grid.Column>
      </Grid.Row>
    </Grid>
  );
};

AssignSiteToItemsComponent.propTypes = {
  allSitesData: PropTypes.array.isRequired,
  allItemsData: PropTypes.array.isRequired,
  resetGridPage: PropTypes.object.isRequired,
  onResetPageOnDataChange: PropTypes.func,
  setIsReadOnlyState: PropTypes.func,
  onFilteredChange: PropTypes.func,
  setSiteGridInstance: PropTypes.func,
  setItemGridInstance: PropTypes.func,
  isReadOnly: PropTypes.bool,
  direction: PropTypes.bool,
  loadingAllSites: PropTypes.bool,
  loadingAllItems: PropTypes.bool,
  rightSideGridReactTableRef: PropTypes.object,
};

AssignSiteToItemsComponent.defaultProps = {
  rightSideGridReactTableRef: null,
  loadingAllSites: false,
  loadingAllItems: false,
  isReadOnly: true,
  direction: true,
  setSiteGridInstance: () => {},
  setItemGridInstance: () => {},
  onResetPageOnDataChange: () => {},
  setIsReadOnlyState: () => {},
  onFilteredChange: () => {},
};

export default AssignSiteToItemsComponent;



// WEBPACK FOOTER //
// ./src/pages/utilities/assignentities/components/assignEntities/AssignSiteToItems.js